export default __webpack_public_path__ + "media/images/lp/Top_main-8c49a93b15e81821ba23c8e57b0317b1.jpg";